/* eslint-disable @typescript-eslint/no-explicit-any, import/prefer-default-export, @typescript-eslint/no-unsafe-argument -- MobX store requires dynamic typing */

import { getRoot } from 'mobx-state-tree';

import type { IRootModel } from 'watchtower-ui/models/Root';

export const getRootStore = (model: any) => {
  const rootModel: IRootModel = getRoot(model);
  return rootModel;
};
